var React = require("react");
var ReactDOM = require('react-dom');
var $ = require('jquery');
var _ = require('underscore');

// Stylesheets
require("./style/common.less");
require("./style/style.less");

// Stores
var LanguageStore = require('./stores/language_store');

// Components
var App = require('./components/app');

// Data
var job_data = JSON.parse($("input[name='job_data']").val());
var other_jobs = JSON.parse($("input[name='other_jobs']").val());
var language = JSON.parse($("input[name='language']").val());
var env_name = $("input[name='env']").val();

// Env info	
var env_info = $("input[name='env_info']").val();
	env_info = (env_info != null && env_info != '' && env_info != 'null') ? JSON.parse(env_info) : null;

LanguageStore.load(language);

// Colors
function hexToRgb(hex) {
    var bigint = parseInt(hex, 16);
    var r = (bigint >> 16) & 255;
    var g = (bigint >> 8) & 255;
    var b = bigint & 255;

    return r + "," + g + "," + b;
}


var customStyle = $('<style></style>');

// Load font
if(typeof env_info.default_job_board_font != 'undefined' && env_info.default_job_board_font != ''){
	var font = env_info.default_job_board_font;
	
	$("<link href='https://fonts.googleapis.com/css?family="+font.replace(/ /ig, '+')+"' rel='stylesheet' type='text/css'>")
	.appendTo($('head'));
	
	customStyle.append("body { font-family:'"+font+"'; }");
	customStyle.append(".apply-button-wrapper button.apply-button { font-family:'"+font+"'; }");

// Default font
} else {
	var font = 'Tinos';
	
	$("<link href='https://fonts.googleapis.com/css?family="+font+"' rel='stylesheet' type='text/css'>")
	.appendTo($('head'));
	
	customStyle.append("body { font-family:'"+font+"'; }");
}
	
if(typeof env_info.colors != 'undefined'){
	_.each(env_info.colors, function(color, key){
		//console.log(color, key);
		
		// Apply button
		if(key === 'job_view_apply_button_text_color'){
			customStyle.append(".wrapper .apply-area .apply-button-wrapper .apply-button { color:"+color+"; }");
			customStyle.append(".wrapper .job-area .apply-button-wrapper .apply-button { color:"+color+"; }");
		}
		
		if(key === 'job_view_apply_button_text_color_hover'){
			customStyle.append(".wrapper .apply-area .apply-button-wrapper .apply-button:hover { color:"+color+"; }");
			customStyle.append(".wrapper .job-area .apply-button-wrapper .apply-button:hover { color:"+color+"; }");
		}
		
		if(key === 'job_view_apply_button_background'){
			customStyle.append(".wrapper .apply-area .apply-button-wrapper .apply-button { background:"+color+"; }");
			customStyle.append(".wrapper .job-area .apply-button-wrapper .apply-button { background:"+color+"; }");
		}
		
		if(key === 'job_view_apply_button_background_hover'){
			customStyle.append(".wrapper .apply-area .apply-button-wrapper .apply-button:hover { background:"+color+"; }");
			customStyle.append(".wrapper .job-area .apply-button-wrapper .apply-button:hover { background:"+color+"; }");
		}
		
		if(key === 'job_view_apply_button_border'){
			customStyle.append(".wrapper .apply-area .apply-button-wrapper .apply-button { border:1px solid "+color+"; }");
			customStyle.append(".wrapper .job-area .apply-button-wrapper .apply-button { border:1px solid "+color+"; }");
		}
		
		if(key === 'job_view_apply_button_border_hover'){
			customStyle.append(".wrapper .apply-area .apply-button-wrapper .apply-button:hover { border:1px solid "+color+"; }");
			customStyle.append(".wrapper .job-area .apply-button-wrapper .apply-button:hover { border:1px solid "+color+"; }");
		}
		
		
		// HIGHLIGHTED Apply button
		if(key === 'highlighted_apply_button_text_color'){
			customStyle.append(".wrapper .apply-area .apply-button-wrapper .apply-button.highlighted { color:"+color+"; }");
			customStyle.append(".wrapper .job-area .apply-button-wrapper .apply-button.highlighted { color:"+color+"; }");
		}
		
		if(key === 'highlighted_apply_button_text_color_hover'){
			customStyle.append(".wrapper .apply-area .apply-button-wrapper .apply-button.highlighted:hover { color:"+color+"; }");
			customStyle.append(".wrapper .job-area .apply-button-wrapper .apply-button.highlighted:hover { color:"+color+"; }");
		}
		
		if(key === 'highlighted_apply_button_background'){
			customStyle.append(".wrapper .apply-area .apply-button-wrapper .apply-button.highlighted { background:"+color+"; }");
			customStyle.append(".wrapper .job-area .apply-button-wrapper .apply-button.highlighted { background:"+color+"; }");
		}
		
		if(key === 'highlighted_apply_button_background_hover'){
			customStyle.append(".wrapper .apply-area .apply-button-wrapper .apply-button.highlighted:hover { background:"+color+"; }");
			customStyle.append(".wrapper .job-area .apply-button-wrapper .apply-button.highlighted:hover { background:"+color+"; }");
		}
		
		if(key === 'highlighted_apply_button_border'){
			customStyle.append(".wrapper .apply-area .apply-button-wrapper .apply-button.highlighted { border:1px solid "+color+"; }");
			customStyle.append(".wrapper .job-area .apply-button-wrapper .apply-button.highlighted { border:1px solid "+color+"; }");
		}
		
		if(key === 'highlighted_apply_button_border_hover'){
			customStyle.append(".wrapper .apply-area .apply-button-wrapper .apply-button.highlighted:hover { border:1px solid "+color+"; }");
			customStyle.append(".wrapper .job-area .apply-button-wrapper .apply-button.highlighted:hover { border:1px solid "+color+"; }");
		}
				
		/*
		// Header text color
		if(key === 'header_text_color'){
			customStyle.append(".env-header h1 { color:"+color+"; }");
		}
		
		// Navigation bar
		if(key === 'nav_bar_background_color'){
			
			if((typeof env_info.colors.nav_bar_background_transparency != 'undefined')){
				var rgb = hexToRgb(color.replace('#', ''));
				var transparency = parseInt(env_info.colors.nav_bar_background_transparency.replace('%', '')) / 100;
				
				customStyle.append(".navigation { background:rgba("+rgb+", "+transparency+"); }");
			} else {
				customStyle.append(".navigation { background:"+color+"; }");
			}				
				
			customStyle.append(".navigation .content .category-list { background:"+color+"; }");
		}
			
		// Navigation bar current-category
		if(key === 'nav_bar_categories_background'){
			customStyle.append(".navigation .content .current-category { background:"+color+"; }");
		}

		if(key === 'nav_bar_categories_background_hover'){
			customStyle.append(".navigation .content .current-category:hover { background:"+color+"; }");
			customStyle.append(".navigation .content .category-list li a:hover { background:"+color+"; }");
		}
			
		if(key === 'nav_bar_categories_text_color'){
			customStyle.append(".navigation .content .current-category { color:"+color+"; }");
		}
			
		if(key === 'nav_bar_categories_text_color_hover'){
			customStyle.append(".navigation .content .current-category:hover { color:"+color+"; }");
			customStyle.append(".navigation .content .category-list li a:hover { color:"+color+"; }");
		}
		
		// Navigation bar home-button
		if(key === 'nav_bar_home_button_background'){
			customStyle.append(".navigation .content .website-home-button { background:"+color+"; }");
		}
			
		if(key === 'nav_bar_home_button_text_color'){
			customStyle.append(".navigation .content .website-home-button { color:"+color+"; }");
		}
			
		if(key === 'nav_bar_home_button_background_hover'){
			customStyle.append(".navigation .content .website-home-button:hover { background:"+color+"; }");
		}
			
		if(key === 'nav_bar_home_button_text_color_hover'){
			customStyle.append(".navigation .content .website-home-button:hover { color:"+color+"; }");
		}
			
		// Navigation bar apply-button
		if(key === 'nav_bar_apply_button_background'){
			customStyle.append(".navigation .content .website-apply-button { background:"+color+"; }");
		}
			
		if(key === 'nav_bar_apply_button_text_color'){
			customStyle.append(".navigation .content .website-apply-button { color:"+color+"; }");
		}
			
		if(key === 'nav_bar_apply_button_background_hover'){
			customStyle.append(".navigation .content .website-apply-button:hover { background:"+color+"; }");
		}
			
		if(key === 'nav_bar_apply_button_text_color_hover'){
			customStyle.append(".navigation .content .website-apply-button:hover { color:"+color+"; }");
		}
			
		// Navigation bar subscribe-button
		if(key === 'nav_bar_subscribe_button_background'){
			customStyle.append(".navigation .content .subscribe-button { background:"+color+"; }");
		}
			
		if(key === 'nav_bar_subscribe_button_text_color'){
			customStyle.append(".navigation .content .subscribe-button { color:"+color+"; }");
		}
			
		if(key === 'nav_bar_subscribe_button_background_hover'){
			customStyle.append(".navigation .content .subscribe-button:hover { background:"+color+"; }");
		}
			
		if(key === 'nav_bar_subscribe_button_text_color_hover'){
			customStyle.append(".navigation .content .subscribe-button:hover { color:"+color+"; }");
		}
		*/
		
	});
}
	
customStyle.appendTo('head');

// Render app to body
ReactDOM.render(<App env_info={env_info} env={env_name} env_name={env_name} job_id={job_data.job_id} job={job_data} other_jobs={other_jobs} job_data={job_data} />, document.getElementById('app'));